export const CANCELLED = '_CANCELLED';
export const FAILURE = '_FAILURE';
export const REQUEST = '_REQUEST';
export const RESET = '_RESET';
export const SUCCESS = '_SUCCESS';
